import React from 'react';
import BookingForm from './BookingForm';

const App = () => (
    <div>
        <BookingForm />
    </div>
);

export default App;
